import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { AcmicService } from "@mapfre-design-library/src/public_api";

@Injectable({
    providedIn: 'root'
})
export class AdobeHelperService {
    constructor(private acmicService: AcmicService) {

    }
    public injectScript() {
        if (this.acmicService.isACMIC()) {
            const adobeScriptEl = document.createElement('script');
            let adobeScriptUrl = '';
            adobeScriptUrl = environment.adobeScript;
            adobeScriptEl.setAttribute('src', adobeScriptUrl);
            adobeScriptEl.setAttribute('async', '');
            document.head.appendChild(adobeScriptEl);
        }
    }
}